import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ResProduct, ResSearchFilterSmart, ResSearchFilterOnBooking, ResSearchFilterOnBookingStatus, ResSearchFilterPreferences, ResProductType } from '../models/res-package.model';
import { GeoTreeDestination } from '@app/res-setup/models/resadm-geo.model';
import { ResAdmAmenityTree } from '@app/res-common/models/rescom.model';
import { EidosUtilityService } from '@app/core/services/eidos-utility.service';
import { ResBooking } from '../models/res-booking.model';

// da spostare in una file model
// interface IProductSearchFilter {
//   companies?: string;
//   productCod?: string[];
//   propertyName?: string;
//   destinations?: string;
//   monthFrom?: string;
//   departureDate?: string;
//   returnDate?: string;
//   currency?: string;
//   priceType?: number[];
//   voyageNumber?: string;
//   ship?: string;
//   packageType?: string;
//   availableCategory?: string;
// }

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  productSearchSmartFilters = new BehaviorSubject<ResSearchFilterSmart[]>([])
  productSearchFilterUserPreferences: any | null = null // product search filters selected by the user
  checkedProductsList =  new BehaviorSubject<ResProduct[]>([]); //FOR POSSIBLE FUTURE USES -> list of all products checked by the user
  checkedCombinableProductsList =  new BehaviorSubject<ResProduct[]>([]); // list of combinable products checked by the user
  isProductSearchFiltersCleaned = new BehaviorSubject<boolean>(false) // subscribe to it to handle when the user click on the clear button in the search bar
  selectedDestinations = new BehaviorSubject<GeoTreeDestination[]>([]);
  selectedAmenities = new BehaviorSubject<ResAdmAmenityTree[]>([]);

  productSearchFiltersStatus = new ResSearchFilterOnBookingStatus()
  smartFilterOnBookingStatus = new BehaviorSubject<boolean>(false)
  constructor(
    private eidosUtilityService: EidosUtilityService,
  ) {}

  clearFilterStatus() {
    this.productSearchFiltersStatus.onBooking = false
    this.productSearchFiltersStatus.previousFilters = {}
  }
  setFilterOnBookingFromBooking(booking:ResBooking,productType:ResProductType,preferences:any){
    this.clearFilterStatus()
    const params = new ResSearchFilterOnBooking()
    params.companies = [booking.companyID]
    params.productCodes = [productType]
    params.priceTypes = booking.priceTypeID ? [booking.priceTypeID] : []
    params.currencies = [booking.bkgCurrency]
    params.preferences = preferences
    this.setFilterOnBooking(params)
  }
  setFilterOnBooking(params:ResSearchFilterOnBooking) {
    this.loadSmartFilter(params.preferences)
    this.productSearchFiltersStatus.onBooking = true
    this.productSearchFiltersStatus.previousFilters = this.eidosUtilityService.cloneDeep(this.productSearchFilterUserPreferences)
    this.productSearchFilterUserPreferences = {
      companies: params.companies,
      productCod: params.productCodes,
      //          monthFrom: Array.from(months),
      currency: params.currencies,
      priceType: params.priceTypes,
    }
    this.productSearchFiltersStatus.onBooking = true
    const newSmartFilters = this.productSearchSmartFilters.getValue()
    if(newSmartFilters.length===0) return
    this.productSearchFiltersStatus.previousSmartFilters = this.eidosUtilityService.cloneDeep(newSmartFilters)
    newSmartFilters.forEach(sf=>{
      switch(sf.section) {
        case 'PRODUCT CODES':
          sf.disabled = true
          sf.items.forEach(item=>{
            item.on = params.productCodes.includes(item.cod)
          })
          break;
      }
    })
    this.smartFilterOnBookingStatus.next(true)
    this.productSearchSmartFilters.next(newSmartFilters)
    this.setCurrenciesFilterOnBookingBehavior()
  }
  setCurrenciesFilterOnBookingBehavior() {

  }
  setCurrenciesFilter() {
    if(this.productSearchFiltersStatus.onBooking) {
      this.setCurrenciesFilterOnBookingBehavior()
      return
    }

  }
  resetFilterOnBooking(filters:ResSearchFilterPreferences) {
    this.productSearchFiltersStatus.onBooking = false
    this.productSearchFilterUserPreferences = {}
    const newSmartFilters = this.productSearchFiltersStatus.previousSmartFilters.length > 0
                          ? this.productSearchFiltersStatus.previousSmartFilters
                          : filters.smartFilters
    const productCodes = filters.values.productCodes
    newSmartFilters.forEach(sf=>{
      switch(sf.section) {
        case 'PRODUCT CODES':
          sf.disabled = false
          if(!sf.items.find(item=>item.favourite)) {
            sf.items.forEach(item=>{
              item.on = productCodes.includes(item.cod) || item.on
            })
          }
          break;
      }
    })
    this.productSearchSmartFilters.next(this.productSearchFiltersStatus.previousFilters)

  }
  setFilterOffBooking() {
    this.productSearchFiltersStatus.onBooking = false
    this.setCurrenciesFilter()
    this.productSearchSmartFilters.next(this.productSearchFiltersStatus.previousSmartFilters)
    this.productSearchFilterUserPreferences = this.productSearchFiltersStatus.previousFilters
  }
  loadSmartFilter(preferences: ResSearchFilterPreferences, productCode?: string, onBooking = false) {
    const smartFilters = preferences.smartFilters
    .filter(sf=>sf.items.find(item=>item.on))
    .map(sf=>{
      if(productCode) {
        sf.disabled = true
        sf.items.forEach(item=>{
          item.on = item.cod===productCode
        })
      }

      const selected = new ResSearchFilterSmart()
      selected.section = sf.section
      selected.items = sf.items.filter(sf=>sf.on)
      return selected
    })

    if(!onBooking) this.productSearchSmartFilters.next(smartFilters)

    this.setCurrenciesFilter()
  }
}
